module.exports = __webpack_public_path__ + "assets/img/icon_store.94c70623.png";